module.exports = __webpack_public_path__ + "img/mercuriale.08290ab4.png";